import { md5 } from 'js-md5'
import { CustomRequestOptions } from '@/interceptors/request'
import { getEnvBaseUrl } from '@/utils'
import { envConfig } from '@/utils/env'
import { parseUrl } from '@/utils/url'

// 请求基准地址
const baseUrl = getEnvBaseUrl().baseUrl

export class Sign {
  // 时间差
  static timeDifference: number = 0

  // 密钥
  private static secretKey: string = 'RTWsRIg0ekNc0P2208k'

  // 存储本地时间和服务器时间的时间差
  static async getTimeDifference() {
    uni.request({
      url: envConfig.timeRequestUrl,
      success: (data) => {
        try {
          this.timeDifference = Number(data.data as string) - new Date().getTime()
        }
        catch (e) {
          this.timeDifference = 0
        }
      },
    })
  }

  // 签名方法
  static signAuth(options: CustomRequestOptions) {
    let path: string = ''

    if (options.url.startsWith('http')) {
      // console.log('含有htttps')
      const urlObj = parseUrl(options.url)
      // console.log(urlObj)
      path = urlObj.path
    }
    else {
      const urlObj = parseUrl(baseUrl + options.url)
      // console.log(urlObj)
      path = urlObj.path
    }
    // H5 开发态鉴权请求会先经过本地代理，签名仍使用后端实际接收的路径。
    // #ifdef H5
    if (envConfig.useH5Proxy && path.startsWith(import.meta.env.VITE_APP_PROXY_AUTH_PREFIX)) {
      path = path.slice(import.meta.env.VITE_APP_PROXY_AUTH_PREFIX.length) || '/'
    }
    // #endif
    // 16位时间戳
    const timestamp = Math.floor((new Date().getTime() + this.timeDifference) / 1000).toString(16)

    // const timestamp = (new Date().getTime()+this.timeDifference).toString(16)

    // MD5（密钥+ Path + timestamp）。
    // 生成sign
    const md5Sign = md5(`${this.secretKey}${path}${timestamp}`)

    if (options.query) {
      options.query.sign = md5Sign
      options.query.t = timestamp
    }
    else {
      options.query = {
        sign: md5Sign,
        t: timestamp,
      }
    }
  }
}
